<template>
  <div class="section-wrapper">
    <InvoiceListModal
      v-if="isLease"
      :is-show-modal-active="isShowListModalActive"
      @setIsShowModalActive="setIsShowListModalActive"
      @setInvoice="setInvoice"
    />

    <section class="order-seikyu">
      <table class="table">
        <tr>
          <th>請求先は貴社宛ですか？</th>
          <td>
            <div class="row">
              <div class="col-md-3">
                <validation-provider v-slot="{ errors }" rules="required">
                  <b-form-select
                    v-model="form.SKS_DIRECT_FLG"
                    :state="errors.length ? false : null"
                    :options="[
                      { text: 'はい', value: 0 },
                      { text: 'いいえ', value: 1 },
                    ]"
                    trim
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </td>
        </tr>
      </table>

      <InvoiceEdit
        v-if="Number(form.SKS_DIRECT_FLG)"
        :is-invoice-valid-active="isInvoiceValidActive"
        :parent-form="form"
        @setIsInvoiceValid="onSetIsInvoiceValid"
        @showFavListModal="setIsShowListModalActive"
        @setInvoice="onSetInvoice"
      />
    </section>
  </div>
</template>

<script>
import Valid from '@/valid'
import { validationMixin } from 'vuelidate'
import {
  required,
  numeric,
  maxLength,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators'
import Mixin from '@/components/mixin/Mixin'
import InvoiceListModal from '@/components/order/invoice/InvoiceListModal'
import InvoiceEdit from '@/components/order/invoice/InvoiceEdit'
import _ from 'lodash'

const _form = {
  SKS_DIRECT_FLG: 0,
  SKS_KAISYA: null,
  SKS_BUSYO: null,
  SKS_YUBIN1: null,
  SKS_YUBIN2: null,
  SKS_TODO: null,
  SKS_TODO_CD: null,
  SKS_JYUSYO1: null,
  SKS_JYUSYO_CD: '',
  SKS_TEL: null,
  SKS_FAX: null,
  SKS_MAIL_ADDR: null,
  SKS_TANTO_MEI: null,
  SKS_TANTO_MEI_SEI: null,
  SKS_IS_FAVORITE_SAVE: null,
}
export default {
  name: 'Invoice',
  components: { InvoiceListModal, InvoiceEdit },

  mixins: [validationMixin, Mixin],

  props: {
    /** バリデーション実行フラグ */
    isInvoiceValidActive: {
      type: Boolean,
      default: false,
    },

    /** 入力データ */
    parentForm: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    /** 入力データ */
    form: {
      SKS_DIRECT_FLG: 0,
      SKS_KAISYA: null,
      SKS_BUSYO: null,
      SKS_YUBIN1: null,
      SKS_YUBIN2: null,
      SKS_TODO: null,
      SKS_TODO_CD: null,
      SKS_JYUSYO1: null,
      SKS_JYUSYO_CD: '',
      SKS_TEL: null,
      SKS_FAX: null,
      SKS_MAIL_ADDR: null,
      SKS_TANTO_MEI: null,
      SKS_TANTO_MEI_SEI: null,
      SKS_IS_FAVORITE_SAVE: null,
    },

    /** お気に入り一覧モーダル表示発火フラグ **/
    isShowListModalActive: false,
  }),

  created() {
    for (var name in _form) {
      if (this.parentForm[name] !== undefined)
        this.form[name] = this.parentForm[name]
      else this.form[name] = _form[name]
    }
  },

  methods: {
    /**
     * Setter お気に入りリスト発火フラグ
     * @param {Boolean} val
     */
    setIsShowListModalActive(val) {
      this.isShowListModalActive = val
    },

    /**
     * 請求先データをセットする
     * @param invoice invoice
     */
    setInvoice(invoice) {
      this.form = _.merge(this.form, invoice)
    },

    /** 親にデータを渡す */
    onSetInvoice(invoice) {
      this.$emit('setInvoice', _.merge(this.form, invoice))
    },

    /** バリデーション結果を通知する */
    onSetIsInvoiceValid(invalid) {
      this.$emit('setIsInvoiceValid', invalid)
      this.$emit('setIsInvoiceValidActive')
    },
  },

  computed: {
    /* 請求先お気に入り一覧 */
    invoiceFavList() {
      return this.$store.state.invoice.data
    },
  },

  watch: {
    /* バリデーション発火フラグ */
    isInvoiceValidActive(val) {
      // 請求先が貴社宛の場合
      if (val && !Number(this.form.SKS_DIRECT_FLG)) {
        this.onSetInvoice(_.cloneDeep(_form))
        this.$emit('setIsInvoiceValid', true)
        this.$emit('setIsInvoiceValidActive')
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../../assets/css/logico2'
section.order-seikyu
  table
    th
      background: $baseBlueColor
      color: #fff
      width: 32%
      padding: 1.5%
    td
      width: 68%
      background: #fff
</style>



// WEBPACK FOOTER //
// src/components/order/invoice/Invoice.vue